import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-authenticate',
  templateUrl: './authenticate.component.html',
  styleUrls: ['./authenticate.component.scss']
})
export class AuthenticateComponent implements OnInit {

  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit() {
    this.authService.generateLinkedinAuthUrl().subscribe(resLinkedinAuthUrl => {
      if (resLinkedinAuthUrl.status === 'verified') {
        window.location.href = 'http://localhost:4300/helpdesk/ticket-view/all';
      } else if (resLinkedinAuthUrl.status === 'unverified') {
        window.location.href = resLinkedinAuthUrl.auth_url;
      } else {
        this.router.navigate(['/dashboard']);
      }
    });
  }

}
